var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.167 65.3789C122.167 96.6297 96.8097 121.976 65.5152 121.976C34.2206 121.976 8.86365 96.6297 8.86365 65.3789C8.86365 34.1282 34.2206 8.78223 65.5152 8.78223C96.8097 8.78223 122.167 34.1282 122.167 65.3789Z",
    stroke: "white",
    strokeWidth: 17
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.e9175a11f3d9643c1f5d356d30ab0086.svg";
export { ForwardRef as ReactComponent };